import { createAction, props } from '@ngrx/store';
import { GetUserLocalDate$Response } from '@api/types';

export const getLocalDate = createAction('[Menus] Get local date');
export const getLocalDateFail = createAction('[Menus] Get local date fail', props<{ error: any }>());
export const getLocalDateSuccess = createAction('[Menus] Get local date success', props<GetUserLocalDate$Response>());
